/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsColorListItem,
    SharedserviceMelcoModelsColorListItemFromJSON,
    SharedserviceMelcoModelsColorListItemFromJSONTyped,
    SharedserviceMelcoModelsColorListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAddColorCollection
 */
export interface SharedserviceMelcoModelsAddColorCollection {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAddColorCollection
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsAddColorCollection
     */
    service?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsColorListItem>}
     * @memberof SharedserviceMelcoModelsAddColorCollection
     */
    color_list?: Array<SharedserviceMelcoModelsColorListItem> | null;
}

export function SharedserviceMelcoModelsAddColorCollectionFromJSON(json: any): SharedserviceMelcoModelsAddColorCollection {
    return SharedserviceMelcoModelsAddColorCollectionFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAddColorCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAddColorCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'service': !exists(json, 'service') ? undefined : json['service'],
        'color_list': !exists(json, 'color_list') ? undefined : (json['color_list'] === null ? null : (json['color_list'] as Array<any>).map(SharedserviceMelcoModelsColorListItemFromJSON)),
    };
}

export function SharedserviceMelcoModelsAddColorCollectionToJSON(value?: SharedserviceMelcoModelsAddColorCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'service': value.service,
        'color_list': value.color_list === undefined ? undefined : (value.color_list === null ? null : (value.color_list as Array<any>).map(SharedserviceMelcoModelsColorListItemToJSON)),
    };
}


